import styled from "styled-components";

import Divider from "../../../layout/Divider";

import { StyledAccordionDividerProps } from "./AccordionItem.types";

export const StyledAccordionItemDivider = styled(
	Divider
)<StyledAccordionDividerProps>`
	margin: 0;
`;
